import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// import User from './modules/user'
import login from './modules/loginInfo'
import history from './modules/history'
export default createStore({
  state: {
    searchTop:0,
    equipmentType:''
  },
  getters:{
    // getIndex:(state)=>{
    //   return state.index*10
    // },
  },
  mutations: {
    SET_HEAD_HEIGHT:(state:any,val:any)=>{
      // state.searchTop=val
    },
    SET_SEARCH_TOP:(state:any,val:any)=>{
      state.searchTop=val
    },
    SET_EQUIPMENT_TYPE:(state:any,val:any)=>{
      state.equipmentType=val
    }
  },
  actions: {
  },
  modules: {
    // User,
    login,
    history
  },
  plugins:[
    createPersistedState({
      storage:window.sessionStorage,
      // paths:['Login']
    })
  ]

})
